<div class="p-4 rodape">
  <div class="row">
    <div class="col-md-3 col-12 mt-3 rodape-item">
      <img class="w-50 m-auto" src="/assets/insignianew.png" alt="" />
      <ul class="text-desc mt-3">
        <li>
          <a routerLink="/contactos" class="text-desc fw-bold">
            <i class="la la-phone me-1 icon-small text-main"></i> 
            Contactos
          </a>
        </li>
        <li>
          <a routerLink="/endereco" class="text-desc fw-bold">
            <i class="la la-map-marker me-1 icon-small text-main"></i> 
            Onde estamos
          </a>
        </li>
      </ul>
    </div>

    <div class="col-md-3 col-12 mt-3 rodape-item">
      <!--h4 class="text-title text-main">SOLUÇÕES MUTUALISTAS</h4-->
      <h4 class="text-title text-main">
        <a
          class="text-title text-main"
          href="https://responsabilidadecredito.bna.ao/Usuario/Login?ReturnUrl=%2F"
          target="_blank"
          >CIRC</a>
      </h4>
    </div>

    <div class="col-md-3 col-12 mt-3 rodape-item">
      <a class="text-title text-main" routerLink="/glossario">Glossário</a>
    </div>

    <div class="col-md-3 col-12 mt-3 rodape-item">
      <h4 class="text-title text-main">
        <a class="text-title text-main" routerLink="/links-uteis">Links Úteis</a>
      </h4>
      <!--ul class="text-desc">
        <li>SIRC</li>
        <li>Sala de Imprensa</li>
        <li>Perguntas Frequentes</li>
      </ul-->
    </div>
  </div>
</div>
